import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const { pathname } = useLocation();

  const handleLinkClick = (path: string) => {
    if (pathname === path) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-agora-ink text-agora-cream py-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-20">
          <div className="col-span-1 md:col-span-2 space-y-8">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-agora-rust rounded-full flex items-center justify-center">
                <span className="text-white font-serif text-xl font-bold">A</span>
              </div>
              <span className="font-serif text-2xl font-bold tracking-tight">The Local Agora</span>
            </div>
            <p className="text-lg opacity-50 max-w-sm leading-relaxed">
              Elevating Windsor-Essex's extraordinary talent through a curated discovery marketplace.
            </p>
          </div>

          <div className="space-y-6">
            <h4 className="text-[10px] uppercase tracking-[0.25em] font-bold opacity-40 font-sans">Ecosystem</h4>
            <ul className="space-y-4">
              <li><Link to="/" onClick={() => handleLinkClick('/')} className="text-sm hover:text-agora-rust transition-colors">Marketplace</Link></li>
              <li><Link to="/about" onClick={() => handleLinkClick('/about')} className="text-sm hover:text-agora-rust transition-colors">Our Story</Link></li>
              <li><Link to="/join" onClick={() => handleLinkClick('/join')} className="text-sm hover:text-agora-rust transition-colors">Partner with Us</Link></li>
            </ul>
          </div>

          <div className="space-y-6">
            <h4 className="text-[10px] uppercase tracking-[0.25em] font-bold opacity-40 font-sans">Contact</h4>
            <ul className="space-y-4">
              <li className="text-sm opacity-50 leading-relaxed font-sans cursor-pointer hover:opacity-100 transition-opacity">Windsor, Ontario, Canada</li>
              <li className="text-sm opacity-50 leading-relaxed font-sans cursor-pointer hover:opacity-100 transition-opacity">hello@thelocalagora.com</li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between gap-8">
          <p className="text-xs opacity-30 font-medium font-sans">© 2026 The Local Agora Inc. All rights reserved.</p>
          <div className="flex gap-8">
            <Link to="/privacy-policy" onClick={() => handleLinkClick('/privacy-policy')} className="text-xs opacity-30 font-medium hover:opacity-100 hover:text-agora-rust cursor-pointer font-sans transition-all">Privacy Policy</Link>
            <Link to="/terms-of-use" onClick={() => handleLinkClick('/terms-of-use')} className="text-xs opacity-30 font-medium hover:opacity-100 hover:text-agora-rust cursor-pointer font-sans transition-all">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
